import { Component, OnInit } from '@angular/core';
import { LoaderService } from "../../../resources/services/loader.service";

@Component({
  selector: 'ui-kit',
  templateUrl: './ui-kit.component.html',
  providers: [ LoaderService ]
})
export class UiKitComponent implements OnInit {

  constructor(private _loaderService: LoaderService) { }

  ngOnInit() {
    setTimeout(() => {
      this._loaderService.hide();
    }, 1000);
  }

  loaderToggle() {
    this._loaderService.toggle();
  }

}
